/**
 * Configuration for the trade-expiry {@link TimeSelector} component.
 *
 * Both selection modes ("Duration" and "Time") read their fast-select ("Quick")
 * presets from here, so the visible ladder can be tuned in one place without
 * touching component logic.
 */

/** Selection mode for the expiry picker. */
export enum ETimeSelectorMode {
  /** Relative length of the trade, e.g. `30s`, `1m`, `4h`. */
  DURATION = "duration",
  /** Absolute wall-clock expiry, e.g. `17:30`, computed from "now". */
  TIME = "time",
}

/** Step between consecutive absolute-time "Quick" presets, in minutes. */
export const TIME_QUICK_STEP_MINUTES = 5;

/** Number of absolute-time "Quick" presets to render (3×3 grid). */
export const TIME_QUICK_COUNT = 9;

/**
 * Bounds for the manual ("Custom") duration stepper, in seconds. The stepper
 * never lets the user leave this range.
 */
export const DURATION_MIN_SECONDS = 5;
export const DURATION_MAX_SECONDS = 24 * 3600 - 1; // 23:59:59
